import axios from 'axios';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import * as constants from '../Constants';
import environment from '../environments/environment';
import NewUser from './NewUser';
import UpdateUser from './UpdateUser';
import UserRoles from './UserRoles';
import UserSubmit from './UserSubmit';

class UserCreation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            UsersList: [],
            rolename: 'Admin',
            supervisorsList: [],
            supervisor: '',
            update: false
        }
    }

    nextStep = () => {
        const { step } = this.state
        if (step === 4) {
            this.setState({
                ...this.state,
                step: 2
            })
        } else {
            this.setState({
                ...this.state,
                step: step + 1
            })
        }
    }

    previousStep = () => {
        const { step } = this.state
        this.setState({
            ...this.state,
            step: step - 1
        })
    }

    secondStep = () => {
        this.setState({
            ...this.state,
            step: 1
        });
    }

    stepFour = () => {
        this.setState({
            ...this.state,
            step: 4
        });
    }

    firstStep = () => {
        this.setState({
            step: 1,
            UsersList: [],
            rolename: 'Admin',
            supervisor: '',
        }, () => {
            this.getSuperviosorsList();
        });
    }

    handleChanges = (recard, selected) => {
        this.assignUser(recard, selected);
    }

    assignUser(recard, selected) {
        if (selected) {
            let UserVO = {}
            UserVO.firstName = recard.givenName;
            UserVO.lastName = recard.surName;
            UserVO.mailId = recard.mailId;
            UserVO.middleName = "";
            UserVO.parentId = 0;
            UserVO.createdBy = this.props.userStatus.emailId;
            UserVO.lastUpdatedBy = this.props.userStatus.emailId;
            UserVO.isActive = constants.IS_ACTIVE_YES;
            UserVO.supervisorr = ''
            this.setState({
                ...this.state,
                UsersList: this.state.UsersList.concat([UserVO]),
                update: false
            }, () => {
                this.createRoles();
            })
        } else {
            this.setState({
                ...this.state,
                UsersList: this.state.UsersList.filter(user => user.firstName !== recard.givenName)
            })
        }

    }

    onRolesChange = input => e => {
        this.setState({
            ...this.state,
            rolename: input
        }, () => {
            if (this.state.rolename === "Admin" || this.state.rolename === "Supervisor") {
                this.setState({
                    ...this.state,
                    UsersList: this.state.UsersList.map((user) => {
                        Object.assign(user, { parentId: 0, supervisorr: '' })
                    })
                }, () => {
                    this.setState({
                        ...this.state,
                        supervisor: ""
                    })
                })
            }
            this.createRoles();
        })
    }

    onSupervisorChange = (value) => {
        this.setState({
            ...this.state,
            supervisor: value
        }, () => {
            let id = 0;
            for (let i = 0; i < this.state.supervisorsList.length; i++) {
                if (this.state.supervisorsList[i].supervisor === value) {
                    id = this.state.supervisorsList[i].supervisorId;
                    break;
                }
            }

            this.setState({
                ...this.state,
                UsersList: this.state.UsersList.map((user) => (
                    Object.assign(user, { parentId: id, supervisorr: value })
                ))
            })
        })

    }

    createRoles() {
        let newUsers = this.state.UsersList;
        for (let i = 0; i < newUsers.length; i++) {
            if (newUsers[i].roles === undefined) {
                let RoleVo = {}
                if (this.state.rolename === "Attorney") {
                    RoleVo.roleId = 1;
                } else if (this.state.rolename === "Supervisor") {
                    RoleVo.roleId = 2;
                } else if (this.state.rolename === "Admin") {
                    RoleVo.roleId = 3;
                }
                RoleVo.roleName = this.state.rolename;
                RoleVo.isActive = constants.IS_ACTIVE_YES;
                RoleVo.createdBy = this.props.userStatus.emailId;
                RoleVo.lastUpdatedBy = this.props.userStatus.emailId;
                RoleVo.createdTime = '1643002937000';
                RoleVo.lastUpdatedTime = '1643002937000';
                newUsers[i].roles = [];
                newUsers[i].roles.push(RoleVo);
            } else {
                if (this.state.rolename === "Attorney") {
                    newUsers[i].roles[0].roleId = 1;
                } else if (this.state.rolename === "Supervisor") {
                    newUsers[i].roles[0].roleId = 2;
                } else if (this.state.rolename === "Admin") {
                    newUsers[i].roles[0].roleId = 3;
                }
                if (this.state.update) {
                    newUsers[i].lastUpdatedBy = this.props.userStatus.emailId;
                    newUsers[i].lastUpdatedTime = null;
                    newUsers[i].roles[0].lastUpdatedBy = this.props.userStatus.emailId;
                    newUsers[i].roles[0].lastUpdatedTime = null;
                }
                newUsers[i].roles[0].roleName = this.state.rolename;
            }
        }
        this.setState({
            ...this.state,
            UsersList: newUsers
        })
    }

    getUserDetails = (user) => {
        this.setState({
            ...this.state,
            UsersList: this.state.UsersList.concat([user]),
            rolename: user.roles[0].roleName,
            supervisor: user.supervisorr,
            update: true
        }, () => {
            if (this.state.rolename === "Admin" || this.state.rolename === "Supervisor") {
                let name = this.state.UsersList[0].firstName + " " + this.state.UsersList[0].lastName;
                this.setState({
                    ...this.state,
                    supervisorsList: this.state.supervisorsList.filter(supervisor => supervisor.supervisor !== name),
                    step: 4
                })
            } else {
                this.setState({
                    ...this.state,
                    step: 4
                })
            }
        })
    }

    getSuperviosorsList() {
        axios.get(environment.getAllSupervisors).then(response => {
            if (response.data !== undefined && response.data !== null) {
                this.setState({
                    ...this.state,
                    supervisorsList: response.data
                })
            }
        })
    }

    componentDidMount() {
        if (this.props.userStatus.userName !== "") {
            if (Object.keys(this.props.userDetails.userDetails).length !== 0) {
                this.getUserDetails(this.props.userDetails.userDetails);
            }
            this.getSuperviosorsList();
        } else {
            this.setState({
                reDirect: '/',
            })
        }
       
    }



    render() {
        if (this.state.reDirect) {
            return <Redirect
                to={{
                    pathname: this.state.reDirect
                }} />
        }
        const { step } = this.state
        const { rolename, UsersList, supervisorsList, supervisor, newUsersList, update } = this.state
        const values = { rolename, UsersList, supervisorsList, supervisor, newUsersList, update }
        switch (step) {
            case 1:
                return (
                    <NewUser nextStep={this.nextStep} prevStep={this.previousStep} values={values}
                        handleChanges={this.handleChanges}
                        firstStep={this.firstStep}></NewUser>
                );
            case 2:
                return (
                    <UserRoles nextStep={this.nextStep} prevStep={this.previousStep} handleChanges={this.handleChanges}
                        values={values} onRolesChange={this.onRolesChange} onSupervisorChange={this.onSupervisorChange}
                        firstStep={this.firstStep} stepFour={this.stepFour}></UserRoles>
                );
            case 3:
                return (
                    <UserSubmit nextStep={this.nextStep} prevStep={this.previousStep} values={values}
                        secondStep={this.secondStep} firstStep={this.firstStep} stepFour={this.stepFour}></UserSubmit>
                );
            case 4:
                return (
                    <UpdateUser nextStep={this.nextStep} prevStep={this.previousStep} values={values}
                        secondStep={this.secondStep} firstStep={this.firstStep}
                        getUserDetails={this.getUserDetails} ></UpdateUser>
                );
            default:
                return <h1> </h1>;
        }
    }
}
const mapStateToProps = (state) => {
    return {
        userStatus: state.lognReducer,
        userDetails: state.usersReducer
    }
}
export default connect(mapStateToProps)(UserCreation);